import { colors } from "theme";

import ClientTranslation from "components/ClientTranslation";
import Flex from "components/Flex";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";

import { WarningIcon } from "../Icons/Warning";

export const InternalDamageWarning = () => {
  const { t } = useClientTranslation();

  return (
    <div>
      <Flex
        as="div"
        gap={4}
        px={12}
        py={12}
        style={{
          backgroundColor: colors.yellow[5],
          borderRadius: "4px",
          border: `1px solid ${colors.yellow[10]}`,
        }}
      >
        <Flex as="div" gap={6} direction="row" align="center">
          <WarningIcon alt="Warning" />
          <Text as="p" sizeVariant="md" style={{ fontWeight: 600 }} dataTestId="internalDamageHeader">
            <ClientTranslation i18nKey={"internal_damage.warning.header"} pl={4}>
              {t("internal_damage.warning.header")}
            </ClientTranslation>
          </Text>
        </Flex>
        <Text as="p" sizeVariant="md" dataTestId="internalDamageBody">
          <ClientTranslation i18nKey={"internal_damage.warning.body"}>
            {t("internal_damage.warning.body")}
          </ClientTranslation>
        </Text>
      </Flex>
    </div>
  );
};
